@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row items-center w-full">
      @if (field.browserOpts.inLineWithCaption) {
        <mat-label class="mr-2 mb-4 font-medium">
          {{ field.label | localize }}
        </mat-label>
      }
      <mat-form-field class="w-full">
        @if (!field.browserOpts.inLineWithCaption) {
          <mat-label>{{ field.label | localize }}</mat-label>
        }
        <input matInput type="number" [formControl]="field.control" [placeholder]="field.placeholder | localize"
                [readonly]="field.readonly" [required]="field.required" [ngClass]="{
                    'text-left': field.browserOpts.alignment === 'LEFT',
                    'text-center': field.browserOpts.alignment === 'CENTER',
                    'text-right': field.browserOpts.alignment === 'RIGHT'
                }" />
          @if (field.hint) {
            <mat-hint>{{ field.hint | localize }}</mat-hint>
          }
          @if (field.control.hasError('required') && !field.readonly) {
            <mat-error>
              {{ 'errorRequiredField' | transloco }}
            </mat-error>
          }
          @if (field.control.hasError('min') && !field.readonly) {
            <mat-error>
              {{ 'errorMinValueField' | transloco:{ min: field.control.errors.min.min } }}
            </mat-error>
          }
          @if (field.control.hasError('max') && !field.readonly) {
            <mat-error>
              {{ 'errorMaxValueField' | transloco:{ max: field.control.errors.max.max } }}
            </mat-error>
          }
          @if (field.control.hasError('maxFractionDigits') && !field.readonly) {
            <mat-error>
              {{ 'errorMaxDecimalDigits' | transloco:{ digits: field.control.errors.maxFractionDigits } }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  } @else {
    {{ field.control.value }}
  }
